import NiceModal from '@ebay/nice-modal-react';

import { Suspense, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Button from 'components/field/Button';
import Loading from 'components/global/Loading';
import PageHeader from 'components/global/PageHeader';
import Tabs from 'components/global/Tabs';

import useModalRouter from 'hooks/useModalRouter';

import PATHS, { mergePaths } from 'utils/paths';

import { faSync } from '@fortawesome/pro-regular-svg-icons';

import GenerateCODReportModal from '../NewCODReports/GenerateCODReportModal';

/**
 * @author @muhammedburakak
 */

const CODPayable = () => {
	const { pathname } = useLocation();
	const { showModal } = useModalRouter();

	const tabs = useMemo(
		() => [
			{
				label: 'newCODReports',
				path: mergePaths(PATHS.COD_PAYABLE, PATHS.NEW_COD_REPORTS)
			},
			{
				label: 'approvedCODReports',
				path: mergePaths(PATHS.COD_PAYABLE, PATHS.APPROVED_COD_REPORTS)
			},
			{
				label: 'cashDepositedReports',
				path: mergePaths(PATHS.COD_PAYABLE, PATHS.CASH_DEPOSITED_REPORTS)
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/logs-icon.json.gz"
				title="CODPayable">
				{pathname === mergePaths(PATHS.COD_PAYABLE, PATHS.NEW_COD_REPORTS) && (
					<Button
						icon={faSync}
						label="generateCODReport"
						onClick={() => NiceModal.show(GenerateCODReportModal)}
						variant="blackOutline"
					/>
				)}

				{pathname === mergePaths(PATHS.COD_PAYABLE, PATHS.NEW_COD_REPORTS) && (
					<Button
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
						label="add"
						onClick={() => showModal('cod-report-modal', { mode: 'add' })}
						variant="blue"
						className="addButton"
					/>
				)}
			</PageHeader>

			<Tabs data={tabs} checkURL />
			<Suspense fallback={<Loading />}>
				<Outlet />
			</Suspense>
		</div>
	);
};

export default CODPayable;
